import { DataSource } from 'src/constants';

export const filterSuggested = <T extends Models.V3.SourcedBase>(x: T): boolean => (
    x.source !== DataSource.Suggested
);
